if (!customElements.get('notify-me-app')) {
class NotifyMeApp extends HTMLElement {
  constructor() {
    super();
    this.button = this.querySelector('.custom-restock-button');
    this.productContent = this.querySelector('.notify-me-content--product-info');
    this.privacyContent = this.querySelector('.notify-me-content--privacy');
    this.bottomContent = this.querySelector('.notify-me-content--bottom');
    this.closeSvg = `<svg class="restock-alerts-modal-close-btn modalCloseButtonStyle tw-text-light-dark" style="z-index:-1;" xmlns="http://www.w3.org/2000/svg" width="9.192" height="9.192" viewBox="0 0 9.192 9.192"><g transform="translate(4.596 -3.889) rotate(45)"><line y2="12" transform="translate(6)" fill="none" stroke="currentColor" stroke-width="1"/><line y2="12" transform="translate(12 6) rotate(90)" fill="none" stroke="currentColor" stroke-width="1"/></g></svg>`;
    this.checkboxPrivacy = this.querySelector('#input-privacy-custom');
    this.popupTitle = window.notifyMe.popupTitle;

    this.restockWrapper = null;

    // If you need to have the required checkbox
    // this.handleCheckboxChange = this.handleCheckboxChange.bind(this);
    // if (this.checkboxPrivacy) {
    //   this.checkboxPrivacy.addEventListener('change', this.handleCheckboxChange);
    // }
    this.handleButtonClick = this.handleButtonClick.bind(this);
    if (this.button) {
      this.button.addEventListener('click', this.handleButtonClick, true);
    }
  }

  disconnectedCallback() {
    this.popupObserver?.disconnect();
  }

  handleButtonClick() {
    this.popupObserver?.disconnect();
    const customizeWhenReady = () => {
      const wrapper = document.querySelector('.restock-alerts-modal-wrapper');
      if (!wrapper?.querySelector('.restock-alerts-modal-box') ||
          !wrapper.querySelector('.restock-alerts-form')) return;

      this.popupObserver.disconnect();
      if (wrapper !== this.restockWrapper) {
        this.customizePopup(wrapper);
        this.restockWrapper = wrapper;
      }
    };

    // The app can insert its wrapper before this click or fill it in later.
    this.popupObserver = new MutationObserver(customizeWhenReady);
    this.popupObserver.observe(document.body, { childList: true, subtree: true });
    customizeWhenReady();
  }

  customizePopup(wrapper) {
    let restockClose = wrapper.querySelector('.restock-alerts-modal-close-btn');
    let restockModalBox = wrapper.querySelector('.restock-alerts-modal-box');
    let restockForm = wrapper.querySelector('.restock-alerts-form');
    let restokFormTitle = wrapper.querySelector('.restock-alerts-form-title');
    let restockLowerSection = wrapper.querySelector('.modalBoxLowerSectionStyle');
    let restockSubmitButton = wrapper.querySelector('.restock-alerts-submit-button');

    // If you need to have the required checkbox
    // const isChecked = this.checkboxPrivacy.checked;
    // if (isChecked) {
    //   restockSubmitButton.removeAttribute('disabled');
    // } else {
    //   restockSubmitButton.setAttribute('disabled', '');
    // }

    if (restockModalBox) {
      restockModalBox.classList.add('restock-popup-open');
      restockModalBox.classList.add('tw-bg-arn-default', 'dark:tw-bg-arn-dark-default');
    }

    if (this.closeSvg && restockClose) {
      // const encoded = `data:image/svg+xml,${encodeURIComponent(this.closeSvg)}`;
      // restockClose.setAttribute('src', encoded);
      restockClose.style.opacity = '0';
      restockClose.insertAdjacentHTML('afterend', this.closeSvg);
    }

    if (this.productContent && restokFormTitle) {
      restockForm.insertBefore(this.productContent, restokFormTitle.nextSibling);
      this.productContent.classList.remove('tw-hidden');
    }

    if (restokFormTitle && this.popupTitle) {
      // restokFormTitle.textContent = this.popupTitle;
      restokFormTitle.style.display = 'none';
      restokFormTitle.insertAdjacentHTML('beforebegin', `<span class="tw-typo-arn-h3 tw-text-light-dark">${this.popupTitle}</span>`);
    }

    if (this.privacyContent && restockSubmitButton) {
      restockLowerSection.insertBefore(this.privacyContent, restockSubmitButton);
      this.privacyContent.classList.remove('tw-hidden');
    }

    if (this.bottomContent && restockSubmitButton) {
      restockLowerSection.insertBefore(this.bottomContent, restockSubmitButton.nextSibling);
      this.bottomContent.classList.remove('tw-hidden');
    }
  }

  handleCheckboxChange() {
    const isChecked = this.checkboxPrivacy.checked;
    if (isChecked) {
      this.restockWrapper.querySelector('.restock-alerts-submit-button').removeAttribute('disabled');
    } else {
      this.restockWrapper.querySelector('.restock-alerts-submit-button').setAttribute('disabled', '');
    }
  }

}

customElements.define('notify-me-app', NotifyMeApp);
}
